import { useNavigate } from "react-router";
import { BasicDialog } from "../../../../components/modal/BasicDialog";
import { CUSTOMERS } from "../../../../constants/routes";
import { useSupplierRelationshipDelete } from "../../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipDelete";

export const DeleteConnectionAsSupplierDialog = ({
  active,
  onDismiss,
  connection,
}: {
  active: boolean;
  onDismiss: () => void;
  connection: {
    id: number;
    SupplierId: number;
    RetailerId: number;
    Retailer: {
      Business: {
        name: string;
      };
    };
    Supplier: {
      Business: {
        name: string;
      };
    };
  };
}) => {
  const connectionDelete = useSupplierRelationshipDelete(connection.id);

  const buyerName = connection.Retailer.Business.name;

  const navigate = useNavigate();

  return (
    <BasicDialog
      loading={connectionDelete.isPending}
      dialogActive={active}
      onDismiss={onDismiss}
      title={`Delete connection with ${buyerName}?`}
      description={`This will remove your connection with ${buyerName}. You will lose your customer notes associated with them. This cannot be undone.`}
      dismissButtonText={"Cancel"}
      onDelete={() =>
        connectionDelete.mutate(undefined, {
          onSuccess: () => {
            navigate(CUSTOMERS);
          },
          onSettled: () => onDismiss(),
        })
      }
    />
  );
};
